// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__bx3av","tabs":"Tabs_tabs__oqX31","tab":"Tabs_tab__-kF8G","active":"Tabs_active__O-bqr","pane":"Tabs_pane__6FHay"};